import { createAsyncThunk } from '@reduxjs/toolkit';
import DashboardService from '@/services/DashboardService';
import TasksService from '@/services/TasksService';

const handler = (name, asyncFunction) =>
  createAsyncThunk(`Dashboard/${name}`, async (arg) => {
    const data = await asyncFunction(arg);
    return data;
  });

const getPendingEvents = handler(
  'getPendingEvents',
  DashboardService.getPendingEvents
);

const getUnassignedInquiries = handler(
  'getUnassignedInquiries',
  DashboardService.getUnassignedInquiries
);

const getVisitsToConfirm = handler(
  'getVisitsToConfirm',
  DashboardService.getVisitsToConfirm
);

const getPropertiesPendingReview = handler(
  'getPropertiesPendingReview',
  DashboardService.getPropertiesPendingReview
);

const getDevelopmentsPendingReview = handler(
  'getDevelopmentsPendingReview',
  DashboardService.getDevelopmentsPendingReview
);

const getQprecoMarketplace = handler(
  'getQprecoMarketplace',
  DashboardService.getQprecoMarketplace
);

const getMarketplaceRegistrationQuality = handler(
  'getMarketplaceRegistrationQuality',
  DashboardService.getMarketplaceRegistrationQuality
);

const getPendingContacts = handler(
  'getPendingContacts',
  DashboardService.getPendingContacts
);

const getPendingLeads = handler(
  'getPendingLeads',
  DashboardService.getPendingLeads
);

const getPendingReservations = handler(
  'getPendingReservations',
  DashboardService.getPendingReservations
);

const getPortalsNotifications = handler(
  'getPortalsNotifications',
  DashboardService.getPortalsNotifications
);

const getExclusivityProperties = handler(
  'getExclusivityProperties',
  DashboardService.getExclusivityProperties
);

const getExpiringRentProperties = handler(
  'getExpiringRentProperties',
  DashboardService.getExpiringRentProperties
);

const getContactChatChannel = handler(
  'getContactChatChannel',
  DashboardService.getContactChatChannel
);

const getOverviewSummary = handler(
  'getOverviewSummary',
  DashboardService.getOverviewSummary
);

const getOverviewContactsSource = handler(
  'getOverviewContactsSource',
  DashboardService.getOverviewContactsSource
);

const getOverviewLeads = handler(
  'getOverviewLeads',
  DashboardService.getOverviewLeads
);

const getOverviewPendingEvents = handler(
  'getOverviewPendingEvents',
  DashboardService.getOverviewPendingEvents
);

const getOverviewOperationStatistics = handler(
  'getOverviewOperationStatistics',
  DashboardService.getOverviewOperationStatistics
);

const getOverviewVisitEvents = handler(
  'getOverviewVisitEvents',
  DashboardService.getOverviewVisitEvents
);

const getOverviewPropertiesOperations = handler(
  'getOverviewPropertiesOperations',
  DashboardService.getOverviewPropertiesOperations
);

const getOverviewPropertiesTypes = handler(
  'getOverviewPropertiesTypes',
  DashboardService.getOverviewPropertiesTypes
);

const getOverviewPropertiesLocations = handler(
  'getOverviewPropertiesLocations',
  DashboardService.getOverviewPropertiesLocations
);

const getOverviewConstructionAge = createAsyncThunk(
  'Dashboard/getOverviewConstructionAge',
  async (arg, { getState }) => {
    const data = await DashboardService.getOverviewConstructionAge(arg);
    const { theme } = getState().UserSlice.themeConfig;
    return { ...data, theme };
  }
);

const getOverviewStaleProperties = createAsyncThunk(
  'Dashboard/getOverviewStaleProperties',
  async (arg, { getState }) => {
    const data = await DashboardService.getOverviewStaleProperties(arg);
    const { theme } = getState().UserSlice.themeConfig;
    return { ...data, theme };
  }
);

const getOverviewStaleContacts = createAsyncThunk(
  'Dashboard/getOverviewStaleContacts',
  async (arg, { getState }) => {
    const data = await DashboardService.getOverviewStaleContacts(arg);
    const { theme } = getState().UserSlice.themeConfig;
    return { ...data, theme };
  }
);

const getOverviewDevelopmentsTypes = handler(
  'getOverviewDevelopmentsTypes',
  DashboardService.getOverviewDevelopmentsTypes
);

const getOverviewDevelopmentsLocations = handler(
  'getOverviewDevelopmentsLocations',
  DashboardService.getOverviewDevelopmentsLocations
);

const getOverviewEntryDate = createAsyncThunk(
  'Dashboard/getOverviewEntryDate',
  async (arg, { getState }) => {
    const data = await DashboardService.getOverviewEntryDate(arg);
    const { theme } = getState().UserSlice.themeConfig;
    return { ...data, theme };
  }
);

const getOverviewTasks = handler(
  'getOverviewTasks',
  DashboardService.getOverviewTasks
);

const editOverviewTask = handler('editOverviewTask', TasksService.editTask);

const getPerformanceReceivedLeadsCard = handler(
  'getPerformanceReceivedLeadsCard',
  DashboardService.getPerformanceReceivedLeadsCard
);

const getPerformanceAddedPropertiesCard = handler(
  'getPerformanceAddedPropertiesCard',
  DashboardService.getPerformanceAddedPropertiesCard
);

const getPerformanceDoneVisitsCard = handler(
  'getPerformanceDoneVisitsCard',
  DashboardService.getPerformanceDoneVisitsCard
);

const getPerformanceDoneEventsCard = handler(
  'getPerformanceDoneEventsCard',
  DashboardService.getPerformanceDoneEventsCard
);

const getPerformanceNewContactsCard = handler(
  'getPerformanceNewContactsCard',
  DashboardService.getPerformanceNewContactsCard
);

const getPerformanceConcretedOperationsCard = handler(
  'getPerformanceConcretedOperationsCard',
  DashboardService.getPerformanceConcretedOperationsCard
);

const getPerformanceResponseTimeCard = handler(
  'getPerformanceResponseTimeCard',
  DashboardService.getPerformanceResponseTimeCard
);

const getPerformanceConversionRateCard = handler(
  'getPerformanceConversionRateCard',
  DashboardService.getPerformanceConversionRateCard
);

const getPerformanceClosedLeadsCard = handler(
  'getPerformanceClosedLeadsCard',
  DashboardService.getPerformanceClosedLeadsCard
);

const getPerformanceReservationCard = handler(
  'getPerformanceReservationCard',
  DashboardService.getPerformanceReservationCard
);

const getPerformanceConversionTimeCard = handler(
  'getPerformanceConversionTimeCard',
  DashboardService.getPerformanceConversionTimeCard
);

const getPerformanceProductionRateCard = handler(
  'getPerformanceProductionRateCard',
  DashboardService.getPerformanceProductionRateCard
);

const getPerformanceVisitEventsCard = handler(
  'getPerformanceVisitEventsCard',
  DashboardService.getPerformanceVisitEventsCard
);

const getPerformanceMedianResponseTimeCard = handler(
  'getPerformanceMedianResponseTimeCard',
  DashboardService.getPerformanceMedianResponseTimeCard
);

const getPerformancePropertyConsultationsCard = handler(
  'getPerformancePropertyConsultationsCard',
  DashboardService.getPerformancePropertyConsultationsCard
);

const getPerformanceDevelopmentConsultationsCard = handler(
  'getPerformanceDevelopmentConsultationsCard',
  DashboardService.getPerformanceDevelopmentConsultationsCard
);

const getPerformanceReceivedLeadsMiniCard = handler(
  'getPerformanceReceivedLeadsMiniCard',
  DashboardService.getPerformanceReceivedLeadsMiniCard
);

const getPerformanceConversionRateMiniCard = handler(
  'getPerformanceConversionRateMiniCard',
  DashboardService.getPerformanceConversionRateMiniCard
);

const getPerformanceDoneEventsMiniCard = handler(
  'getPerformanceDoneEventsMiniCard',
  DashboardService.getPerformanceDoneEventsMiniCard
);

const getPerformanceAddedPropertiesMiniCard = handler(
  'getPerformanceAddedPropertiesMiniCard',
  DashboardService.getPerformanceAddedPropertiesMiniCard
);

const getPerformanceConcretedOperationsMiniCard = handler(
  'getPerformanceConcretedOperationsMiniCard',
  DashboardService.getPerformanceConcretedOperationsMiniCard
);

const getPerformanceConversionTimeMiniCard = handler(
  'getPerformanceConversionTimeMiniCard',
  DashboardService.getPerformanceConversionTimeMiniCard
);

const getPerformanceNewContactsMiniCard = handler(
  'getPerformanceNewContactsMiniCard',
  DashboardService.getPerformanceNewContactsMiniCard
);

const getPerformanceResponseTimeMiniCard = handler(
  'getPerformanceResponseTimeMiniCard',
  DashboardService.getPerformanceResponseTimeMiniCard
);

const getPerformanceNewContactsTable = handler(
  'getPerformanceNewContactsTable',
  DashboardService.getPerformanceNewContactsTable
);

const getPerformanceInquiriesReceivedTable = handler(
  'getPerformanceInquiriesReceivedTable',
  DashboardService.getPerformanceInquiriesReceivedTable
);

const getPerformanceDoneVisitsTable = handler(
  'getPerformanceDoneVisitsTable',
  DashboardService.getPerformanceDoneVisitsTable
);

const getPerformanceDoneEventsTable = handler(
  'getPerformanceDoneEventsTable',
  DashboardService.getPerformanceDoneEventsTable
);

const getPerformanceConversionTimeTable = handler(
  'getPerformanceConversionTimeTable',
  DashboardService.getPerformanceConversionTimeTable
);

const getPerformanceResponseTimeTable = handler(
  'getPerformanceResponseTimeTable',
  DashboardService.getPerformanceResponseTimeTable
);

const getPerformanceAddedPropertiesTable = handler(
  'getPerformanceAddedPropertiesTable',
  DashboardService.getPerformanceAddedPropertiesTable
);

const getPerformanceConversionRateTable = handler(
  'getPerformanceConversionRateTable',
  DashboardService.getPerformanceConversionRateTable
);

const getPerformanceConcretedOperationsTable = handler(
  'getPerformanceConcretedOperationsTable',
  DashboardService.getPerformanceConcretedOperationsTable
);

const getPerformancePropertyConsultationsTable = handler(
  'getPerformancePropertyConsultationsTable',
  DashboardService.getPerformancePropertyConsultationsTable
);

const getPerformanceDevelopmentConsultationsTable = handler(
  'getPerformanceDevelopmentConsultationsTable',
  DashboardService.getPerformanceDevelopmentConsultationsTable
);

const getPerformanceClosedLeadsTable = handler(
  'getPerformanceClosedLeadsTable',
  DashboardService.getPerformanceClosedLeadsTable
);

const getPerformanceReservationsCreatedTable = handler(
  'getPerformanceReservationsCreatedTable',
  DashboardService.getPerformanceReservationsCreatedTable
);

const getPerformanceAgentsPerformanceTable = handler(
  'getPerformanceAgentsPerformanceTable',
  DashboardService.getPerformanceAgentsPerformanceTable
);

const getPerformanceProductionRateTable = handler(
  'getPerformanceProductionRateTable',
  DashboardService.getPerformanceProductionRateTable
);

const getPerformanceConcretedOperationsEvolutionCard = handler(
  'getPerformanceConcretedOperationsEvolutionCard',
  DashboardService.getPerformanceConcretedOperationsEvolutionCard
);

const getPerformanceConcretedOperationsSourceCard = handler(
  'getPerformanceConcretedOperationsSourceCard',
  DashboardService.getPerformanceConcretedOperationsSourceCard
);

const putDashboardConfig = handler(
  'putDashboardConfig',
  DashboardService.putDashboardConfig
);

export {
  getPendingEvents,
  getContactChatChannel,
  getUnassignedInquiries,
  getVisitsToConfirm,
  getPropertiesPendingReview,
  getDevelopmentsPendingReview,
  getQprecoMarketplace,
  getMarketplaceRegistrationQuality,
  getPendingContacts,
  getPendingLeads,
  getPendingReservations,
  getPortalsNotifications,
  getExclusivityProperties,
  getExpiringRentProperties,
  getOverviewSummary,
  getOverviewContactsSource,
  getOverviewLeads,
  getOverviewPendingEvents,
  getOverviewOperationStatistics,
  getOverviewVisitEvents,
  getOverviewPropertiesOperations,
  getOverviewPropertiesTypes,
  getOverviewPropertiesLocations,
  getOverviewConstructionAge,
  getOverviewStaleProperties,
  getOverviewStaleContacts,
  getOverviewDevelopmentsTypes,
  getOverviewDevelopmentsLocations,
  getOverviewEntryDate,
  getOverviewTasks,
  editOverviewTask,
  getPerformanceReceivedLeadsCard,
  getPerformanceAddedPropertiesCard,
  getPerformanceDoneVisitsCard,
  getPerformanceDoneEventsCard,
  getPerformanceNewContactsCard,
  getPerformanceConcretedOperationsCard,
  getPerformanceResponseTimeCard,
  getPerformanceConversionRateCard,
  getPerformanceClosedLeadsCard,
  getPerformanceReservationCard,
  getPerformanceProductionRateCard,
  getPerformanceConversionTimeCard,
  getPerformanceVisitEventsCard,
  getPerformanceMedianResponseTimeCard,
  getPerformancePropertyConsultationsCard,
  getPerformanceDevelopmentConsultationsCard,
  getPerformanceReceivedLeadsMiniCard,
  getPerformanceConversionRateMiniCard,
  getPerformanceDoneEventsMiniCard,
  getPerformanceAddedPropertiesMiniCard,
  getPerformanceConcretedOperationsMiniCard,
  getPerformanceConversionTimeMiniCard,
  getPerformanceNewContactsMiniCard,
  getPerformanceResponseTimeMiniCard,
  getPerformanceNewContactsTable,
  getPerformanceInquiriesReceivedTable,
  getPerformanceDoneVisitsTable,
  getPerformanceDoneEventsTable,
  getPerformanceResponseTimeTable,
  getPerformanceAddedPropertiesTable,
  getPerformanceConversionTimeTable,
  getPerformanceConversionRateTable,
  getPerformanceConcretedOperationsTable,
  getPerformancePropertyConsultationsTable,
  getPerformanceDevelopmentConsultationsTable,
  getPerformanceClosedLeadsTable,
  getPerformanceReservationsCreatedTable,
  getPerformanceAgentsPerformanceTable,
  getPerformanceProductionRateTable,
  getPerformanceConcretedOperationsEvolutionCard,
  getPerformanceConcretedOperationsSourceCard,
  putDashboardConfig,
};
